export const getConfig = stringName => {
    return process.env[`REACT_APP_${stringName}`] || null;
};
